interface AppInfoProps {
  name: string
  logoUrl?: string | null
  homepageUrl?: string | null
}

export function AppInfo({ name, logoUrl, homepageUrl }: AppInfoProps) {
  return (
    <div className="flex items-center gap-4">
      {logoUrl ? (
        <img
          src={logoUrl}
          alt={`${name} logo`}
          className="h-12 w-12 rounded-lg object-cover"
        />
      ) : (
        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-br from-[var(--text-primary)] to-[var(--text-secondary)] text-xl font-bold text-[var(--bg-base)]">
          {name.charAt(0).toUpperCase()}
        </div>
      )}
      <div>
        <h2 className="text-lg font-semibold text-[var(--text-primary)]">
          {name}
        </h2>
        {homepageUrl && (
          <p className="text-sm text-[var(--text-secondary)]">
            {new URL(homepageUrl).hostname}
          </p>
        )}
      </div>
    </div>
  )
}
